/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetSovereigntyMap200Ok
 */
export interface GetSovereigntyMap200Ok {
    /**
     * alliance_id integer
     * @type {number}
     * @memberof GetSovereigntyMap200Ok
     */
    allianceId?: number;
    /**
     * corporation_id integer
     * @type {number}
     * @memberof GetSovereigntyMap200Ok
     */
    corporationId?: number;
    /**
     * faction_id integer
     * @type {number}
     * @memberof GetSovereigntyMap200Ok
     */
    factionId?: number;
    /**
     * system_id integer
     * @type {number}
     * @memberof GetSovereigntyMap200Ok
     */
    systemId: number;
}

/**
 * Check if a given object implements the GetSovereigntyMap200Ok interface.
 */
export function instanceOfGetSovereigntyMap200Ok(value: object): value is GetSovereigntyMap200Ok {
    if (!('systemId' in value) || value['systemId'] === undefined) return false;
    return true;
}

export function GetSovereigntyMap200OkFromJSON(json: any): GetSovereigntyMap200Ok {
    return GetSovereigntyMap200OkFromJSONTyped(json, false);
}

export function GetSovereigntyMap200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSovereigntyMap200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'allianceId': json['alliance_id'] == null ? undefined : json['alliance_id'],
        'corporationId': json['corporation_id'] == null ? undefined : json['corporation_id'],
        'factionId': json['faction_id'] == null ? undefined : json['faction_id'],
        'systemId': json['system_id'],
    };
}

export function GetSovereigntyMap200OkToJSON(json: any): GetSovereigntyMap200Ok {
    return GetSovereigntyMap200OkToJSONTyped(json, false);
}

export function GetSovereigntyMap200OkToJSONTyped(value?: GetSovereigntyMap200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'alliance_id': value['allianceId'],
        'corporation_id': value['corporationId'],
        'faction_id': value['factionId'],
        'system_id': value['systemId'],
    };
}

